// ✅ TaskFlow Setup Layout – Desktop + Mobile Perfected
// - Floating hamburger button for mobile (<992px)
// - Sidebar overlays + locks scroll on mobile
// - Content perfectly resizes in desktop expand/collapse
// - No horizontal scroll in any state

import React, { useState, useEffect } from "react";
import SetupSidebar from "../components/SetupSidebar";
import { MdMenu } from "react-icons/md";

export default function SetupLayout({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(
    localStorage.getItem("tf_sidebar_collapsed") === "true"
  );
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

  // ✅ Monitor screen width changes
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 992);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // ✅ Track collapse state changes from localStorage
  useEffect(() => {
    const watcher = setInterval(() => {
      const lsVal = localStorage.getItem("tf_sidebar_collapsed") === "true";
      setCollapsed(lsVal);
    }, 300);
    return () => clearInterval(watcher);
  }, []);

  // ✅ Lock scroll behind sidebar in mobile
  useEffect(() => {
    if (isMobile) {
      document.body.style.overflow = mobileOpen ? "hidden" : "auto";
    }
  }, [mobileOpen, isMobile]);

  // ✅ Dynamic main margin + width
  const sidebarWidth = collapsed ? 64 : 260;
  const mainMargin = !isMobile ? sidebarWidth : 0;

  return (
    <div className="tf-setup-layout" style={{ width: "100%", overflowX: "hidden" }}>
      
      <SetupSidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />

      {/* ✅ Mobile Hamburger */}
      {isMobile && (
        <button
          className="tf-mobile-menu"
          onClick={() => setMobileOpen(true)}
          aria-label="Open Sidebar"
        >
          <MdMenu size={22} />
        </button>
      )}

      {/* ✅ Main Content */}
      <main
        className="tf-main-content"
        style={{
          marginLeft: mainMargin,
          padding: "20px",
          transition: "margin-left 0.25s ease",
          minHeight: "100vh",
          width: isMobile ? "100%" : `calc(100% - ${sidebarWidth}px)`,
          overflowX: "hidden",
          boxSizing: "border-box",
        }}
      >
        {children}
      </main>
    </div>
  );
}
